import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import EmailIcon from "@material-ui/icons/MailOutline";
import PasswordIcon from "@material-ui/icons/LockOutlined";
import { Redirect } from "react-router";
import {
  Dialog,
  DialogActions,
  DialogContent,
  FormHelperText,
} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Button from "@material-ui/core/Button";
import LoadingButton from "../../../components/LoadingButton";
import { callAPI } from "../../../lib/common";
import IconTextField from "../../Mobile/Components/IconTextField";
import Box from "@material-ui/core/Box";
import BoxContainer from "./BoxContainer";
import BoxHeading from "./BoxHeading";
import BoxActions from "./BoxActions";
import { useAuth } from "../../providers/AuthProvider";
import FormikTextField from "../../../components/Common/FormikTextField";
import TextField from "../../Mobile/Components/TextField";
import Level2BoxContainer from "./Level2BoxContainer";
import Level2BoxHeading from "./Level2BoxHeading";
import Popup, {
  PopupContent,
  PopupHeading,
} from "../../../components/Common/Popup";
import ForgotPasswordDialog from "../../Mobile/Components/ForgotPasswordDialog";

const useStyles = makeStyles((theme) => ({
  form: {
    flexGrow: 1,
  },
  button: {
    flexBasis: "100px",
    flexShrink: 0,
    paddingLeft: 0,
    paddingRight: 0,
    flexGrow: 1,
  },
}));

export default ({ handleGoBack, handleLoginSuccess }) => {
  const { t } = useTranslation();
  const {
    isAuthenticating,
    isAuthenticated,
    loginError,
    login: authLogin,
  } = useAuth();
  const classes = useStyles();
  const [forgotPasswordDialogOpen, setForgotPasswordDialogOpen] = useState();

  useEffect(() => {
    if (isAuthenticated) {
      handleLoginSuccess();
    }
  }, [isAuthenticated]);

  const openSendForgotPasswordDialog = (e) => {
    e.preventDefault();
    setForgotPasswordDialogOpen(true);
  };

  return (
    <Level2BoxContainer>
      <Level2BoxHeading color="primary">
        <Trans>Sign in</Trans>
      </Level2BoxHeading>

      <Formik
        initialValues={{
          username: "",
          password: "",
        }}
        validationSchema={loginSchema(t)}
        onSubmit={(values, { setSubmitting, setErrors, setValues }) => {
          // Trim spaces from username:
          setValues({ ...values, username: values.username.trim() });
          authLogin(values.username.trim(), values.password);
        }}
      >
        {({ submitForm, isValid, values }) => {
          return (
            <Form className={classes.form}>
              <Field
                id="login-email-address"
                component={FormikTextField}
                label={t("Email address")}
                name="username"
                variant="outlined"
                autoFocus
                fullWidth
              />
              <Field
                id="login-password"
                component={FormikTextField}
                type="password"
                label={t("Password")}
                name="password"
                variant="outlined"
                fullWidth
              />
              <p>
                <FormHelperText error={!!loginError}>
                  {loginError}
                </FormHelperText>
              </p>

              <p className={classes.subText}>
                <Trans>Forgot your password?</Trans>{" "}
                <Link onClick={openSendForgotPasswordDialog}>
                  <Trans>Click here</Trans>
                </Link>
              </p>

              <BoxActions>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleGoBack}
                  className={classes.button}
                >
                  <Trans>Back</Trans>
                </Button>
                <LoadingButton
                  variant="primary"
                  isLoading={isAuthenticating}
                  onClick={submitForm}
                  disabled={!isValid}
                  className={classes.button}
                >
                  <Trans>Sign in</Trans>
                </LoadingButton>
              </BoxActions>
              {forgotPasswordDialogOpen && (
                <ForgotPasswordDialog
                  email={values.email}
                  onClose={() => setForgotPasswordDialogOpen(false)}
                />
              )}
            </Form>
          );
        }}
      </Formik>
    </Level2BoxContainer>
  );
};

const loginSchema = (t) => () => {
  return Yup.object().shape({
    password: Yup.string()
      .min(3, t("That's too short!"))
      .required(t("This is required!")),
  });
};
